import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  initBillStats,
  resetBillStats,
  initBillList,
  resetBillList,
  initBillRooms,
  resetBillRooms,
  initBillSubjects,
  setSelectedRoom,
  setListFilterParams,
  initOrderMaster,
  initMasterInfo,
} from '@/redux/actions/bill';
import { getOrderDetailBaseInfo } from '@/redux/actions/order';

import BillStats from './stats';
import BillFilter from './filter';
import BillOperates from './operates';
import BillCtrl from './control';
import BillRooms from './rooms';
import BillTable from './table';

// import BillSettle from './settle';
import BillCredit from './credit';
import BillPreSettle from './preSettle';
import BillPartSettle from './partSettle';
// import BillPartRefund from './partRefund';
// import BillReverse from './reverse';
import BillTransfer from './transfer';

import styles from './index.module.scss';

interface UrlParam {
  resvNo?: string;
}

function Bill(props) {
  const { billStatsLoading, billStats, filterParams, selectedRoom } = props;
  const { resvNo } = useParams<UrlParam>();

  // 滚动时页面滚不下去，有抖动
  const [fixedHeader, setFixedHeader] = useState(false);

  const initList = () => {
    const params = {
      ...filterParams,
      recNo: selectedRoom.recNo,
      resvNo,
    };
    if (params.type === -1) delete params.type;
    if (params.status === -1) delete params.status;
    if (params.subjectCode === 'all') delete params.subjectCode;
    if (!params.recNo) delete params.recNo;

    props.initBillList({
      ...params,
    });
  };

  const resetStates = () => {
    props.setSelectedRoom({
      roomId: 0, // 房间id
      roomNo: '', // 房号
      recNo: '', // 子订单号
    });
    props.setListFilterParams({
      type: -1, // 入账类型（全部
      status: -1, // 结账状态（全部）
      subjectCode: 'all', // 账务项目（全部）
    });
  };

  // operates callback
  const reloadList = () => {
    props.initBillStats({
      resvNo,
    });
    props.initBillRooms({
      resvNo,
    });
    props.getOrderDetailBaseInfo({
      resvNo,
    });
    resetStates();
  };

  const bindHandleScroll = () => {
    // 滚动的高度
    const scrollTop =
      document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

    if (scrollTop > 405) {
      setFixedHeader(true);
    }

    if (scrollTop < 405) {
      setFixedHeader(false);
    }

    // fix: fixed区域select下拉框滚动过程仍然显示的问题
    // eslint-disable-next-line no-unused-expressions
    document.getElementById('select-area') && document.getElementById('select-area').blur();
  };

  // init datas
  useEffect(() => {
    props.initBillStats({
      resvNo,
    });
    props.initBillRooms({
      resvNo,
    });
    props.initOrderMaster({
      resvNo,
    });
    props.initMasterInfo({
      resvNo,
    });
    props.getOrderDetailBaseInfo({
      resvNo,
    });
    props.initBillSubjects();

    // 监听页面滚动
    window.addEventListener('scroll', bindHandleScroll);

    return () => {
      // reset states & stores
      resetStates();
      props.resetBillStats();
      props.resetBillList();
      props.resetBillRooms();

      // 移除监听
      window.removeEventListener('scroll', bindHandleScroll);
    };
  }, []);

  // watch filter params change & room change
  useEffect(() => {
    initList();
  }, [selectedRoom, filterParams]);

  return (
    <div className={styles.bill}>
      {/* <BillSettle resvNo={resvNo} reloadList={reloadList} /> */}
      <BillCredit resvNo={resvNo} reloadList={reloadList} />
      <BillPreSettle resvNo={resvNo} reloadList={reloadList} />
      <BillPartSettle resvNo={resvNo} reloadList={reloadList} />
      {/* <BillPartRefund reloadList={reloadList} /> */}
      {/* <BillReverse reloadList={reloadList} /> */}
      <BillTransfer resvNo={resvNo} reloadList={reloadList} />
      <BillStats loading={billStatsLoading} billStats={billStats} />
      <div style={{ marginTop: 24 }}>
        {fixedHeader ? (
          <div>
            <div className={styles['bill-filter-operates']}>
              <BillFilter />
              <BillOperates resvNo={resvNo} reloadList={reloadList} />
            </div>
            <BillCtrl />
          </div>
        ) : null}

        <div className={fixedHeader ? styles.billListHeader : ''}>
          <div className={styles['bill-filter-operates']}>
            <BillFilter />
            <BillOperates resvNo={resvNo} reloadList={reloadList} />
          </div>
          <BillCtrl />
        </div>

        <div className={styles['bill-table-wrapper']}>
          <BillRooms />
          <BillTable reloadList={reloadList} />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { billStatsLoading, billStats, filterParams, selectedRoom } = state.bill;
  return {
    billStatsLoading,
    billStats,
    filterParams,
    selectedRoom,
  };
};

export default connect(mapStateToProps, {
  initBillStats,
  resetBillStats,
  initBillList,
  resetBillList,
  initBillRooms,
  resetBillRooms,
  initBillSubjects,
  setSelectedRoom,
  setListFilterParams,
  initOrderMaster,
  initMasterInfo,
  getOrderDetailBaseInfo,
})(Bill);
